import { render, staticRenderFns } from "./chanPinDialog.vue?vue&type=template&id=6b5563b4&scoped=true"
import script from "./chanPinDialog.vue?vue&type=script&lang=js"
export * from "./chanPinDialog.vue?vue&type=script&lang=js"
import style0 from "./chanPinDialog.vue?vue&type=style&index=0&id=6b5563b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5563b4",
  null
  
)

export default component.exports